import apiClient from '../../core/apiClient';
import { endpoints } from '../../core/endpoints';
import type { Catalog, CreateCatalogDto, UpdateCatalogDto } from './catalogs.types';

const BASE = endpoints.collections.catalogs;

export const getCatalogTypes = (): Promise<Catalog[]> =>
  apiClient.get<Catalog[]>(`${BASE}/types`);

export const getCatalogDescendants = (id: string): Promise<Catalog[]> =>
  apiClient.get<Catalog[]>(`${BASE}/descendants/${id}`);

export const getCatalogAncestors = (id: string): Promise<Catalog[]> =>
  apiClient.get<Catalog[]>(`${BASE}/ancestors/${id}`);

export const createCatalog = (data: CreateCatalogDto): Promise<Catalog> =>
  apiClient.post<Catalog>(BASE, data);

export const updateCatalog = (id: string, data: UpdateCatalogDto): Promise<Catalog> =>
  apiClient.put<Catalog>(`${BASE}/${id}`, data);

export const deleteCatalog = (id: string): Promise<void> =>
  apiClient.delete<void>(`${BASE}/${id}`);
